/**
 * Product Reviews — DOM reorganization for Figma layout
 * - Moves "Rédiger un avis" button into the header meta row
 * - Moves rating stars from review header to content area
 *
 * ⚠️  Ce script dépend de la structure DOM interne de Judge.me
 *     (classes .jdgm-rev, .jdgm-rev__header, .jdgm-widget-actions-wrapper, etc.).
 *     Une mise à jour de l'app Judge.me peut casser ces sélecteurs.
 *     À re-vérifier après chaque update de l'app.
 */
(function () {
  function moveButtonToHeader() {
    const meta = document.querySelector(
      '.shopify-section-product-reviews .reviews-header__meta'
    );
    const actionsWrapper = document.querySelector(
      '.shopify-section-product-reviews .jdgm-widget-actions-wrapper'
    );
    if (meta && actionsWrapper && !meta.contains(actionsWrapper)) {
      meta.appendChild(actionsWrapper);
    }
  }

  function reorganizeReviews() {
    const reviews = document.querySelectorAll(
      '.shopify-section-product-reviews .jdgm-rev'
    );
    reviews.forEach((rev) => {
      const rating = rev.querySelector('.jdgm-rev__header .jdgm-rev__rating');
      const content = rev.querySelector('.jdgm-rev__content');
      if (rating && content && !content.contains(rating)) {
        content.insertBefore(rating, content.firstChild);
      }
    });
  }

  function init() {
    moveButtonToHeader();
    reorganizeReviews();
  }

  // Run on initial load (Judge.me may already have rendered)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 500));
  } else {
    setTimeout(init, 500);
  }

  // Re-run when Judge.me loads new pages (pagination)
  const observer = new MutationObserver(() => {
    moveButtonToHeader();
    reorganizeReviews();
  });

  const target = document.querySelector('.shopify-section-product-reviews');
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }
})();
